import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLayoutCells, selectFavoriteLayoutCells } from '../store/selectors';
import { debounce } from 'throttle-debounce';
import { doCloseModal } from '../store/actions/modal';
import { doPanToCell } from '../store/actions/channelLayout';
import { ReactComponent as GoToIcon } from '../images/goto.svg'
import firebase from '../lib/firebase'

import styles from './Search.module.scss';
import { CellWithLayoutType } from '../Channel/ChannelDataTypes';

export enum SearchTypes {
  LAYOUT = "layout",
  FAVORITES = "favorites"
}

function FormSearch({cellList}: {cellList: SearchTypes}) {
  const dispatch = useDispatch();
  const layoutCells = useSelector(selectLayoutCells);
  const favoriteCells = useSelector(selectFavoriteLayoutCells);

  let cells: CellWithLayoutType[];

  if (cellList === SearchTypes.FAVORITES) {
    cells = favoriteCells;
  } else {
    cells = layoutCells
  }

  const [results, setResults] = useState(cells);

  const handleSearch = useMemo(() => debounce(200, (term: string) => {
    setResults(cells.filter(cell => cell.title.toLowerCase().includes(term.toLowerCase())));
  }), [cells]);

  const handleClick = (cellId: number) => {
    dispatch(doPanToCell(cellId));
    dispatch(doCloseModal());

    firebase.analytics.logEvent("search_result_selected", {cell_id: cellId});
  }

  let searchResults = results.map(result => <SearchResult key={result.id} title={result.title} onClick={(e: React.MouseEvent) => handleClick(result.id)} />);

  return (
    <div className={styles.wrapper}>
      <form className={styles.form} onSubmit={(e) => {e.preventDefault(); return false;}}>
        <input className={styles.searchInput} autoFocus placeholder="Search" type="search" name="search" onChange={({ target: { value } }) => handleSearch(value)} autoComplete="false" />
      </form>
      <div className={styles.results}>
        { searchResults.length > 0 ? searchResults : <div className={styles.noResults}>No results found.</div> }
      </div>
    </div>
  );
}

type SearchResultProps = {
  title: string,
  onClick: (e: React.MouseEvent) => void
}

function SearchResult({title, onClick}: SearchResultProps) {

  return (
    <div className={styles.result} onClick={onClick}>{ title } <button className={styles.button}><GoToIcon /></button></div>
  )
}

export default FormSearch;

